import * as _ from 'underscore';

import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IActionContext } from '../../../../ts/helpers/ActionContext';
import { IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeExtractDsToLiveAction as AngularChangeExtractDsToLiveAction } from '../../../../ts/services/ChangeExtractDsToLiveAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { ChangeExtractDsToLiveAction } from '../../../actions/spaces/ChangeExtractDsToLiveAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';
import { reloadSpace } from '../content/RefreshContentSagas';

export function* handleChangeExtractDsToLiveAction(action: ChangeExtractDsToLiveAction) {

  try {
    yield call(openChangeExtractDsToLiveWindow,  action.datasources);
    yield call(reloadSpace); // force to reload the page after change extract to live
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openChangeExtractDsToLiveWindow(datasources: IDataSourceInfo[]) {
  const filteredDs: IDataSourceInfo[] = datasources.filter(ds =>
    ds.hasExtracts && !ds.isExtractOnly && !ds.isFileBased && ds.connectionType !== 'sqlproxy');
  if(filteredDs.length < 1) {
    return;
  }
  const context: IActionContext = ServiceLocator.getAngularActionContext();
  const angularChangeExtractDsToLiveAction: AngularChangeExtractDsToLiveAction  = ServiceLocator.get<AngularChangeExtractDsToLiveAction>('ChangeExtractDsToLiveAction');
  return angularChangeExtractDsToLiveAction.execute(Set.fromIdItemArray(filteredDs), context);
}
